import React, { useState, useEffect, useCallback, useRef } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import PhoneInput from '../StepFour/PhoneInput/PhoneInput';
import SelectInput from '../StepFour/SelectInput/SelectInput';
import Input from '../../../../components/UI/Input/Input';
import styles from './StepOneNew.module.css';
import Checkbox from '../../../../components/UI/Inputs/Checkbox/Checkbox';
import Button from '../../../../components/UI/Button/Button';
import Prompt from '../../../../components/Shared/Prompt/Prompt';
import { checkValidity, updateObject } from '../../../../shared/utility';
import * as actions from '../../../../redux/actions/index';
import * as api from '../../../../api/SignUp';
import {
  applyTestDefaults,
  STEP_ONE_TEST_DEFAULTS,
} from '../../../../utils/signupTestDefaults';

const getSelectedOption = (options, value) => {
  let searchedOption = null;
  Object.values(options).forEach((option) => {
    if (option.value === value) {
      searchedOption = option;
    }
  });
  return searchedOption;
};

const getSelectedState = (states, value) => {
  let result = null;
  Object.values(states).forEach((data) => {
    Object.values(data.options).forEach((stateOption) => {
      if (stateOption.value === value) {
        result = stateOption;
      }
    });
  });
  return result;
};

const customerInfoFormKeys = [
  'email',
  'confirmEmail',
  'full_name',
  'last_name',
  'company',
  'mobile_phone',
  'phone',
  'address',
  'city',
  'state',
  'zip_code',
];

const accInfoFormKeys = [
  'industry',
  'howDidYouHearAboutUs',
  'password',
  'password2',
  'first_security_question',
  'first_question_answer',
  'second_security_question',
  'second_question_answer',
];

const matchErrorMsg = "The two password fields don't match";
const matchErrorEmailMsg = 'Your email and confirmation email do not match.';

const StepOneNew = (props) => {
  const {
    onSetStep,
    onSetStepCompleted,
    onUpdateSignUpData,
    onInitContext,
    sendGAEvent,
    stepNumber,
    signUpData,
    history,
    states,
    formErrors,
  } = props;

  const location = useLocation();

  const [pendingAccount, setPendingAccount] = useState(false);

  const customerFormErrors =
    formErrors && formErrors.customer_form ? formErrors.customer_form : null;
  const emailsFormErrors =
    formErrors && formErrors.emails_form ? formErrors.emails_form : null;
  const inputScheme = {
    email: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 59,
        isEmail: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Email:',
      doNotCopyPast: true,
      inputWrapRef: React.createRef(),
    },
    confirmEmail: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 59,
        isEmail: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Confirm Email:',
      inputWrapRef: React.createRef(),
      matchEmailError: null,
      doNotCopyPast: true,
    },
    full_name: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 59,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Full Name:',
      inputWrapRef: React.createRef(),
    },
    company: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 255,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Company Name:',
      inputWrapRef: React.createRef(),
    },

    mobile_phone: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        minLength: 10,
        maxLength: 10,
        isPhone: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Phone Number:',
      inputWrapRef: React.createRef(),
    },
    address: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 60,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Street Address:',
      inputWrapRef: React.createRef(),
    },
    city: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 60,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'City:',
      inputWrapRef: React.createRef(),
    },
    state: {
      elementType: 'select',
      elementConfig: {
        options: [],
        placeholder: 'Select State',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'State:',
      inputWrapRef: React.createRef(),
    },
    zip_code: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 60,
        isPostalCode: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Zip Code:',
      inputWrapRef: React.createRef(),
    },
    industry: {
      elementType: 'select',
      elementConfig: {
        options: [
          { value: 'Real Estate', label: 'Real Estate' },
          { value: 'Real Estate Investor', label: 'Real Estate Investor' },
          { value: 'Insurance', label: 'Insurance' },
          { value: 'Financial Services', label: 'Financial Services' },
          { value: 'Mortgage', label: 'Mortgage' },
          {
            value: 'Advertising/Marketing',
            label: 'Advertising/Marketing',
          },
          { value: 'Other', label: 'Other' },
        ],
        placeholder: 'Select Industry',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Industry:',
      inputWrapRef: React.createRef(),
    },
    howDidYouHearAboutUs: {
      elementType: 'select',
      elementConfig: {
        options: [
          { value: 'Broker', label: 'Broker' },
          { value: 'Coach', label: 'Coach' },
          { value: 'Friend/Colleague', label: 'Friend/Colleague' },
          { value: 'Facebook Ad', label: 'Facebook Ad' },
          { value: 'Facebook Group', label: 'Facebook Group' },
          { value: 'Google Search', label: 'Google Search' },
          { value: 'Integration Partner', label: 'Integration Partner' },
          {
            value: 'I am a previous Mojo client',
            label: 'I am a previous Mojo client',
          },
          { value: 'Youtube', label: 'Youtube' },
          { value: 'Other', label: 'Other' },
        ],
        placeholder: 'How did you hear about us?',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'How did you hear about us?',
      inputWrapRef: React.createRef(),
    },
    password: {
      elementType: 'input',
      elementConfig: {
        type: 'password',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        minLength: 6,
        maxLength: 120,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Account Password:',
      inputWrapRef: React.createRef(),
    },
    password2: {
      elementType: 'input',
      elementConfig: {
        type: 'password',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        minLength: 6,
        maxLength: 120,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Confirm Password:',
      // matched: true
      matchError: null,
      inputWrapRef: React.createRef(),
    },
    same_billing_address: {
      error: null,
      value: false,
      touched: false,
      is_valid: false,
      validation: {
        required: false,
      },
      ref: React.createRef(),
    },
    first_security_question: {
      elementType: 'select',
      elementConfig: {
        options: [
          // { value: '', label: 'Select Question' },
          { value: '0', label: 'What city were you born in?' },
          { value: '1', label: 'What is your favorite sports team?' },
          { value: '2', label: 'What is the first name of your best friend?' },
        ],
        placeholder: 'Select Question',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Security Question 1:',
      inputWrapRef: React.createRef(),
    },
    first_question_answer: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 255,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Answer 1:',
      inputWrapRef: React.createRef(),
    },
    second_security_question: {
      elementType: 'select',
      elementConfig: {
        options: [
          // { value: '', label: 'Select Question' },
          { value: '0', label: 'What is the maiden name of your mother?' },
          { value: '1', label: 'What was your first job?' },
          {
            value: '2',
            label: 'What is the name of the high school you attended?',
          },
          { value: '3', label: 'What year were you married?' },
        ],
        placeholder: 'Select Question',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Security Question 2:',
      inputWrapRef: React.createRef(),
    },
    second_question_answer: {
      elementType: 'input',
      elementConfig: {
        type: 'text',
        placeholder: '',
        autoComplete: 'off',
      },
      value: '',
      validation: {
        required: true,
        maxLength: 255,
      },
      valid: false,
      error: '',
      touched: false,
      label: 'Answer 2:',
      inputWrapRef: React.createRef(),
    },
  };
  // With `?test=1` in the URL: prefill inputs with test values for fast testing.
  applyTestDefaults(inputScheme, STEP_ONE_TEST_DEFAULTS);
  const inputSchemeKeys = Object.keys(inputScheme);
  const [infoForm, setInfoForm] = useState(inputScheme);
  const [nonFieldErrors, setNonFieldErrors] = useState(false);
  const nonFieldErrorsRef = useRef(null);

  useEffect(() => {
    if (nonFieldErrors && nonFieldErrorsRef.current) {
      nonFieldErrorsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [nonFieldErrors]);

  useEffect(() => {
    if (stepNumber !== 1) {
      onSetStep(1);
    }
    onInitContext();
  }, [onSetStep, stepNumber]);

  // Scroll screen to top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const validateEmail = (inputValue, inputIdentifier) => {
    api
      .getLoginInfoByEmail(inputValue)
      .then((response) => {
        if (response.data.status === 'invalid_data') {
          const updatedFormElement = updateObject(infoForm[inputIdentifier], {
            value: inputValue,
            valid: false,
            error: response.data.message,
            touched: true,
          });
          const updatedForm = updateObject(infoForm, {
            [inputIdentifier]: updatedFormElement,
          });
          setInfoForm(updatedForm);
        } else if (response.data.status === 'free') {
          console.log('Free');
        } else if (response.data.status === 'busy.active') {
          history.push(
            `/login/?status=busy.active&extraData=${encodeURIComponent(
              JSON.stringify({
                pin: response.data.pin,
                email: response.data.email,
              })
            )}`
          );
        } else if (response.data.status === 'busy.cancelled') {
          const updatedFormElement = updateObject(infoForm[inputIdentifier], {
            value: inputValue,
            valid: false,
            error: 'This email is already taken. Please use a different email.',
            touched: true,
          });
          const updatedForm = updateObject(infoForm, {
            [inputIdentifier]: updatedFormElement,
          });
          setInfoForm(updatedForm);
        } else if (response.data.status === 'busy.pending') {
          setPendingAccount(true);
        }
      })
      .catch(() => {
        const updatedFormElement = updateObject(infoForm[inputIdentifier], {
          value: inputValue,
          valid: false,
          error: 'Server error.',
          touched: true,
        });
        const updatedForm = updateObject(infoForm, {
          [inputIdentifier]: updatedFormElement,
        });
        setInfoForm(updatedForm);
      });
  };

  const handleEmailBlur = (inputValue, inputIdentifier) => {
    validateEmail(inputValue, inputIdentifier);
  };

  const inputChangedHandler = (inputValue, inputIdentifier) => {
    const validationInfo = checkValidity(
      inputValue,
      infoForm[inputIdentifier].validation
    );
    const updatedFormElement = updateObject(infoForm[inputIdentifier], {
      value: inputValue,
      valid: validationInfo.isValid,
      error: validationInfo.error,
      touched: true,
    });

    let updatedForm = updateObject(infoForm, {
      [inputIdentifier]: updatedFormElement,
    });

    const form = JSON.parse(localStorage.getItem('preForm') || '{}');
    if (inputIdentifier === 'password' || inputIdentifier === 'password2') {
      form[inputIdentifier] = '';
    } else {
      form[inputIdentifier] = inputValue;
    }
    localStorage.setItem('preForm', JSON.stringify(form));
    localStorage.setItem('savedAt', new Date().toDateString());

    let updatedOtherElement = null;
    if (inputIdentifier === 'other_checkbox') {
      switch (inputValue) {
        case true:
          updatedOtherElement = updateObject(updatedForm.other, {
            value: '',
            validation: {
              required: true,
            },
            valid: false,
            error: '',
            touched: false,
          });
          break;
        case false:
          updatedOtherElement = updateObject(updatedForm.other, {
            value: '',
            validation: {
              required: false,
            },
            valid: true,
            error: '',
            touched: false,
          });
          break;
        default:
          updatedOtherElement = null;
      }
      updatedForm = updateObject(updatedForm, {
        other: updatedOtherElement,
      });
    }

    // clear passwords matching error
    if (inputIdentifier === 'password2' || inputIdentifier === 'password') {
      if (updatedForm.password.value === updatedForm.password2.value) {
        const updatedConfirmPasswordElement = updateObject(
          updatedForm.password2,
          {
            matchError: null,
          }
        );
        updatedForm = updateObject(updatedForm, {
          password2: updatedConfirmPasswordElement,
        });
      }
    }

    // clear passwords matching error
    if (inputIdentifier === 'confirmEmail' || inputIdentifier === 'email') {
      if (updatedForm.email.value === updatedForm.confirmEmail.value) {
        const updatedConfirmPasswordElement = updateObject(
          updatedForm.confirmEmail,
          {
            matchEmailError: null,
          }
        );
        updatedForm = updateObject(updatedForm, {
          confirmEmail: updatedConfirmPasswordElement,
        });
      }
    }
    setInfoForm(updatedForm);
  };

  const checkFormValidity = () => {
    let isValid = true;
    let updatedForm = { ...infoForm };
    // Fire the async email-availability check (separate from local
    // validation). It updates state when it returns and may redirect
    // to /login/ for `busy.active` etc.; it doesn't gate this submit.
    validateEmail(updatedForm.email.value, 'email');

    Object.keys(infoForm)
      //   .filter((inputIdentifier) => inputIdentifier !== 'email')
      .forEach((inputIdentifier) => {
        const validationInfo = checkValidity(
          infoForm[inputIdentifier].value,
          infoForm[inputIdentifier].validation
        );
        const updatedFormElement = updateObject(infoForm[inputIdentifier], {
          value: infoForm[inputIdentifier].value,
          valid: validationInfo.isValid,
          error: validationInfo.error,
          touched: true,
        });
        updatedForm = updateObject(updatedForm, {
          [inputIdentifier]: updatedFormElement,
        });
        isValid = updatedForm[inputIdentifier].valid && isValid;
      });

    // passwords matching check
    let matchError = null;
    if (updatedForm.password2.valid && updatedForm.password.valid) {
      matchError =
        updatedForm.password.value === updatedForm.password2.value
          ? null
          : matchErrorMsg;
    }
    const updatedConfirmPasswordElement = updateObject(updatedForm.password2, {
      matchError,
    });
    updatedForm = updateObject(updatedForm, {
      password2: updatedConfirmPasswordElement,
    });
    isValid = updatedForm.password2.matchError === null && isValid;

    // email matching check
    let matchEmailError = null;
    if (updatedForm.email.valid && updatedForm.confirmEmail.valid) {
      matchEmailError =
        updatedForm.email.value === updatedForm.confirmEmail.value
          ? null
          : matchErrorEmailMsg;
    }
    const updatedConfirmEmailElement = updateObject(updatedForm.confirmEmail, {
      matchEmailError,
    });
    updatedForm = updateObject(updatedForm, {
      confirmEmail: updatedConfirmEmailElement,
    });
    isValid = updatedForm.confirmEmail.matchEmailError === null && isValid;
    return { isValid, updatedForm };
  };

  const syncDataToRedux = useCallback(() => {
    const formData = {};
    Object.keys(infoForm).forEach((controlName) => {
      formData[controlName] = infoForm[controlName].value;
    });
    onUpdateSignUpData(formData);
  }, [onUpdateSignUpData, infoForm]);

  const prefillFormValues = (prefillData) => {
    setInfoForm((previousInfoForm) => {
      let updatedForm = { ...previousInfoForm };
      Object.keys(previousInfoForm).forEach((controlName) => {
        if (prefillData[controlName]) {
          const updatedFormElement = updateObject(
            previousInfoForm[controlName],
            {
              value: prefillData[controlName],
            }
          );
          updatedForm = updateObject(updatedForm, {
            [controlName]: updatedFormElement,
          });
        }
      });
      return {
        ...previousInfoForm,
        ...updatedForm,
      };
    });
  };

  const prefillFormErrors = (prefillData) => {
    setInfoForm((previousInfoForm) => {
      let updatedForm = { ...previousInfoForm };
      Object.keys(previousInfoForm).forEach((controlName) => {
        if (prefillData[controlName]) {
          const updatedFormElement = updateObject(
            previousInfoForm[controlName],
            {
              error: prefillData[controlName],
              valid: false,
              touched: true,
            }
          );
          updatedForm = updateObject(updatedForm, {
            [controlName]: updatedFormElement,
          });
        }
      });
      return {
        ...previousInfoForm,
        ...updatedForm,
      };
    });
    if ('__all__' in prefillData) {
      // eslint-disable-next-line no-underscore-dangle
      setNonFieldErrors(prefillData.__all__);
    }
  };

  const getHighestErrorField = (updatedInputScheme) => {
    let highestField = null;
    Object.keys(updatedInputScheme).forEach((controlName) => {
      if (
        !updatedInputScheme[controlName].valid &&
        updatedInputScheme[controlName].inputWrapRef
      ) {
        if (!highestField) {
          highestField = updatedInputScheme[controlName];
        } else if (
          updatedInputScheme[controlName].inputWrapRef.current &&
          updatedInputScheme[controlName].inputWrapRef.current.offsetTop <
            highestField.inputWrapRef.current.offsetTop
        ) {
          highestField = updatedInputScheme[controlName];
        }
      }
    });

    // custom password matching error ref check
    if (
      updatedInputScheme.password2 &&
      updatedInputScheme.password2.matchError !== null &&
      updatedInputScheme.password2.inputWrapRef
    ) {
      if (!highestField) {
        highestField = updatedInputScheme.password2;
      } else if (
        updatedInputScheme.password2.inputWrapRef.current &&
        updatedInputScheme.password2.inputWrapRef.current.offsetTop <
          highestField.inputWrapRef.current.offsetTop
      ) {
        highestField = updatedInputScheme.password2;
      }
    }

    // custom checkboxes required error ref check (used 'broker' field inputWrapRef)
    if (updatedInputScheme.broker && updatedInputScheme.broker.inputWrapRef) {
      if (!highestField) {
        highestField = updatedInputScheme.broker;
      } else if (
        updatedInputScheme.broker.inputWrapRef.current &&
        updatedInputScheme.broker.inputWrapRef.current.offsetTop <
          highestField.inputWrapRef.current.offsetTop
      ) {
        highestField = updatedInputScheme.broker;
      }
    }
    return highestField;
  };

  useEffect(
    () => {
      if (signUpData) {
        prefillFormValues(signUpData);
      }
      if (customerFormErrors) {
        // testing returned sign-up errors.
        prefillFormErrors(customerFormErrors);

        const highestControl = getHighestErrorField(customerFormErrors);
        if (highestControl) {
          window.scrollTo({
            behavior: 'smooth',
            top: highestControl.inputWrapRef.current.offsetTop - 100,
          });
        }
      }
      if (emailsFormErrors) {
        prefillFormErrors(emailsFormErrors);

        const highestControl = getHighestErrorField(emailsFormErrors);
        if (highestControl) {
          window.scrollTo({
            behavior: 'smooth',
            top: highestControl.inputWrapRef.current.offsetTop - 100,
          });
        }
      }
    },
    // eslint-disable-next-line
    [signUpData, customerFormErrors, emailsFormErrors]
  );

  useEffect(() => {
    const raw = localStorage.getItem('preForm');
    const savedAt = localStorage.getItem('savedAt');
    const today = new Date().toDateString();

    if (raw && savedAt) {
      const savedDate = new Date(savedAt).toDateString();
      if (savedDate === today) {
        const savedForm = JSON.parse(raw);
        prefillFormValues(savedForm);
      } else {
        localStorage.removeItem('preForm');
        localStorage.removeItem('savedAt');
      }
    } else {
      localStorage.removeItem('preForm');
      localStorage.removeItem('savedAt');
    }
  }, []);

  const formSubmittedHandler = (event) => {
    event.preventDefault();
    const formValidationInfo = checkFormValidity();
    if (!formValidationInfo.isValid) {
      setInfoForm(formValidationInfo.updatedForm);
      //   setCheckboxesRequiredError(!formValidationInfo.checkboxCecked);

      const highestControl = getHighestErrorField(
        formValidationInfo.updatedForm
      );
      if (highestControl) {
        window.scrollTo({
          behavior: 'smooth',
          top: highestControl.inputWrapRef.current.offsetTop - 100,
        });
      }
    } else {
      syncDataToRedux();
      onSetStepCompleted(4);
      sendGAEvent('Customer and Account Information -> Billing Information');
      history.push(`/sign-up/step-2${location.search}`);
    }
  };

  const infoFormElementsArray = Object.values(inputSchemeKeys).map((key) => {
    return {
      id: key,
      config: infoForm[key],
    };
  });

  return (
    <div className={styles.Step}>
      <div className={styles.Title}>Customer Information:</div>
      {pendingAccount && (
        <Prompt
          isOpen
          style={{ width: '400px' }}
          title="Warning!"
          onClose={() => setPendingAccount(false)}
          buttons={[
            {
              title: 'Ok',
              clicked: () => setPendingAccount(false),
              type: 'success',
            },
          ]}
        >
          <div style={{ lineHeight: '1.5' }}>
            An account with this email already exists but sign-up wasn&#39;t
            finished yet.
          </div>
        </Prompt>
      )}
      <form autoComplete="off" onSubmit={formSubmittedHandler}>
        {infoFormElementsArray
          .filter((formEl) => customerInfoFormKeys.includes(formEl.id))
          .map((formElement) => {
            if (
              formElement.config.elementType === 'input' &&
              (formElement.id === 'mobile_phone' || formElement.id === 'phone')
            ) {
              return (
                <PhoneInput
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  value={formElement.config.value}
                  invalid={!formElement.config.valid}
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(event) =>
                    inputChangedHandler(event.target.rawValue, formElement.id)
                  }
                  error={formElement.config.error}
                  inputLabelStyle={{ width: '220px' }}
                  autoComplete="off"
                  refProp={formElement.config.inputWrapRef}
                />
              );
            }
            if (
              formElement.config.elementType === 'input' &&
              formElement.id === 'email'
            ) {
              return (
                <Input
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  invalid={!formElement.config.valid}
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(event) =>
                    inputChangedHandler(event.target.value, formElement.id)
                  }
                  blur={(event) =>
                    handleEmailBlur(event.target.value, formElement.id)
                  }
                  error={formElement.config.error}
                  inputLabelStyle={{ width: '220px' }}
                  inputWrapRef={formElement.config.inputWrapRef}
                  doNotCopyPast
                />
              );
            }
            if (formElement.config.elementType === 'input') {
              let error = '';
              if (formElement.config.error) {
                error = formElement.config.error;
              } else if (formElement.config.matchEmailError) {
                error = formElement.config.matchEmailError;
              }
              let doNotCopyPast = false;
              if (formElement.config.doNotCopyPast) {
                doNotCopyPast = true;
              }
              return (
                <Input
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  invalid={!formElement.config.valid}
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(event) =>
                    inputChangedHandler(event.target.value, formElement.id)
                  }
                  error={error}
                  inputLabelStyle={{ width: '220px' }}
                  inputWrapRef={formElement.config.inputWrapRef}
                  doNotCopyPast={doNotCopyPast}
                />
              );
            }
            if (
              formElement.config.elementType === 'select' &&
              formElement.id === 'state'
            ) {
              return (
                <SelectInput
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  value={
                    states && getSelectedState(states, formElement.config.value)
                      ? getSelectedState(states, formElement.config.value)
                      : null
                  }
                  invalid={!formElement.config.valid}
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(option) =>
                    inputChangedHandler(option.value, formElement.id)
                  }
                  error={formElement.config.error}
                  inputLabelStyle={{ width: '220px' }}
                  options={states || []}
                  placeholder={formElement.config.elementConfig.placeholder}
                  autoComplete="off"
                  refProp={formElement.config.inputWrapRef}
                />
              );
            }
            return null;
          })}

        <div className={[styles.Row, styles.SameAddressCheckbox].join(' ')}>
          <div>
            <div>
              <Checkbox
                labelStyle={{ alignItems: 'anchor-center' }}
                isLarge
                isChecked={infoForm.same_billing_address.value}
                autoComplete="off"
                changed={(event) =>
                  inputChangedHandler(
                    event.target.checked,
                    'same_billing_address'
                  )
                }
              >
                <div className={styles.TermsTitle}>
                  The address above is the same as my billing address.
                </div>
              </Checkbox>
            </div>
          </div>
        </div>

        {infoFormElementsArray
          .filter((formEl) => accInfoFormKeys.includes(formEl.id))
          .map((formElement) => {
            if (formElement.config.elementType === 'input') {
              let error = '';
              if (formElement.config.error) {
                error = formElement.config.error;
              } else if (formElement.config.matchError) {
                error = formElement.config.matchError;
              }
              return (
                <Input
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  elementType={formElement.config.elementType}
                  elementConfig={formElement.config.elementConfig}
                  value={formElement.config.value}
                  invalid={
                    !formElement.config.valid || formElement.config.matchError
                  }
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(event) =>
                    inputChangedHandler(event.target.value, formElement.id)
                  }
                  error={error}
                  inputLabelStyle={{ width: '220px' }}
                  inputWrapRef={formElement.config.inputWrapRef}
                />
              );
            }
            if (formElement.config.elementType === 'select') {
              return (
                <SelectInput
                  key={formElement.id}
                  name={formElement.id}
                  label={formElement.config.label}
                  value={getSelectedOption(
                    formElement.config.elementConfig.options,
                    formElement.config.value
                  )}
                  invalid={!formElement.config.valid}
                  shouldValidate={formElement.config.validation}
                  touched={formElement.config.touched}
                  changed={(option) =>
                    inputChangedHandler(option.value, formElement.id)
                  }
                  error={formElement.config.error}
                  inputLabelStyle={{ width: '220px' }}
                  options={formElement.config.elementConfig.options}
                  placeholder={formElement.config.elementConfig.placeholder}
                  defaultValue={formElement.config.elementConfig.options[0]}
                  autoComplete="off"
                  refProp={formElement.config.inputWrapRef}
                />
              );
            }
            return null;
          })}

        <div className={styles.ButtonsWrap}>
          <Button
            type="submit"
            isBtnNext
            style={{
              width: '100%',
              borderRadius: '8px',
              background: '#0053CF',
              textAlign: 'center',
            }}
          >
            Next
          </Button>
        </div>

        {nonFieldErrors && (
          <div ref={nonFieldErrorsRef} className={styles.NonFieldErrors}>
            {nonFieldErrors}
          </div>
        )}
      </form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    stepNumber: state.signUp.stepNumber,
    stepCompleted: state.signUp.stepCompleted,
    signUpData: state.signUp.data,
    totalPrice: state.signUp.totalPrice,
    states: state.signUp.states,
    // tempSignUpData: state.signUp.tempData,
    formErrors: state.signUp.formErrors,
    accountType: state.signUp.accountType,
    dataAndDialerChoice: state.signUp.dataAndDialerChoice,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSetStep: (stepNum) => dispatch(actions.setStepNumber(stepNum)),
    onSetStepCompleted: (stepNum) =>
      dispatch(actions.setStepCompleted(stepNum)),
    onUpdateSignUpData: (signUpdata) =>
      dispatch(actions.updateSignUpData(signUpdata)),
    onInitContext: () => dispatch(actions.initContext()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepOneNew);
